import styled, { css } from "styled-components";
import media from "constants/media";

export const StoresStyled = styled.div`
    background: var(--color-white);

    ${media.mdUp`
        width: 100%;
        max-width: 780px;
        margin: 0 auto;
        box-shadow: 10px 10px 24px 0 rgba(0,23,75,0.05);
    `}
`;

export const Wrapper = styled.div`
    padding: 45px 20px;

    ${media.mdUp`
        padding: 52px 60px 60px;
    `}

    ${({ bottom }) =>
        bottom &&
        css`
            padding-bottom: 0;

            ${media.mdUp`
                padding-bottom: 60px;
             `}
        `}
`;

export const Content = styled.div`
    max-width: 320px;
    margin: 0 auto;

    ${media.mdUp`
        max-width: none;
        margin: 0;
    `}
`;

export const Title = styled.h2`
    margin-bottom: 10px;

    font-size: 25px;
    font-family: var(--font-DINProCondensed);
    line-height: 30px;
    letter-spacing: 1px;
    text-transform: uppercase;

    ${media.mdUp`
        margin-bottom: 18px;
        text-align: center;
        font-size: 32px;
        line-height: 40px;
    `}
`;

export const Text = styled.p`
    margin-bottom: 20px;

    font-size: 14px;
    line-height: 20px;

    ${media.mdUp`
        margin-bottom: 29px;
        text-align: center;
        font-size: 16px;
        line-height: 25px;
    `}
`;

export const Logo = styled.li`
    width: 100%;
    max-width: 33.3%;
    margin-bottom: 20px;

    ${media.mdUp`
        margin-bottom: 50px;
    `}
`;

export const Logos = styled.ul`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 480px;

    margin: 0 auto;

    list-style: none;

    ${({ center }) =>
        center &&
        css`
            > div {
                align-items: center;
                justify-content: center;
            }
        `}

    ${media.mdUp`
        padding: 0 80px;
        max-width: 580px;
    `}
`;

export const Image = styled.div`
    padding: 0 5px;

    img {
        max-width: 100%;
    }
`;

export const Separator = styled.div`
    border-bottom: 1px solid var(--color-lightGrey);
`;
